/**
 * Centered text container used by the static legal pages (`/privacy`, `/terms`).
 *
 * Children should be a sequence of `<p>` and `<h3>` (or `<h4>`) blocks; the
 * wrapper styles them as a readable single-column document. Mirrors the layout
 * of the old Flask `website/privacy.html` / `terms.html` templates, minus the
 * decorative SVG dot patterns (gratuitous, didn't add anything).
 *
 * @param {object} props
 * @param {string} props.heading              Page heading (e.g. "Privacy Policy").
 * @param {React.ReactNode} props.children    Page body.
 */
export default function LegalPage({ heading, children }) {
  return (
    <div className="relative py-16 bg-gray-50">
      <div className="relative px-4 sm:px-6 lg:px-8">
        <div className="text-lg max-w-prose mx-auto">
          <h1 className="mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
            {heading}
          </h1>
        </div>
        <div className="mt-8 max-w-prose mx-auto space-y-4 text-base text-gray-600 leading-7 [&_p]:mt-3 [&_h3]:mt-8 [&_h3]:mb-2 [&_h3]:text-xl [&_h3]:font-semibold [&_h3]:text-gray-900 [&_h4]:mt-6 [&_h4]:mb-2 [&_h4]:text-lg [&_h4]:font-semibold [&_h4]:text-gray-900 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1 [&_a]:text-blue-800 [&_a:hover]:underline">
          {children}
        </div>
      </div>
    </div>
  );
}
